import { render, staticRenderFns } from "./CompartilhamentoDados.vue?vue&type=template&id=3a803a63&scoped=true&lang=pug"
import script from "./CompartilhamentoDados.vue?vue&type=script&lang=js"
export * from "./CompartilhamentoDados.vue?vue&type=script&lang=js"
import style0 from "./CompartilhamentoDados.vue?vue&type=style&index=0&id=3a803a63&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a803a63",
  null
  
)

export default component.exports